import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#1E2B58] px-8 py-14 text-stone-50 sm:px-14" data-id="element-129" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl" data-id="element-130" data-mp="3ggaqfufcyb4x">
        <p className="font-serif text-3xl tracking-tight" data-id="element-131" data-mp="3ghc0pwojutll">
          FINANZA PRONTA<span className="align-super text-[0.5em]" data-id="element-132" data-mp="32pfeuadh5fxn">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-133" data-mp="36ooajks2rnvu">
          FINANZA PRONTA™ è un materiale didattico indipendente e non è una pubblicazione ufficiale del
          Ministero dell'Istruzione e del Merito. Contenuto educativo: non costituisce consulenza finanziaria
          o di investimento. Nomi di banche e app negli esempi sono inventati.
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-134" data-mp="3qcxbaj7op26y">
          © 2026 FINANZA PRONTA™ · edulabs. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}